import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@app/shared/shared.module';
import { AuthPrivateModule } from '@app/auth/private/auth-private.module';
import { ForgotFormComponent } from './components/forgot-form.component';
import { ForgotPageComponent } from './containers/forgot-page.component';
import { ForgotService } from './services/forgot.service';
import { ForgotEffects } from './state/forgot.effects';
import { reducer } from './state/forgot.reducer';

const routes: Routes = [
  {
    path: 'forgot',
    component: ForgotPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    SharedModule,
    AuthPrivateModule,
    StoreModule.forFeature('authForgot', reducer),
    EffectsModule.forFeature([ForgotEffects]),
  ],
  declarations: [ForgotPageComponent, ForgotFormComponent],
  providers: [ForgotService],
})
export class AuthForgotModule {}
